import { CodeBook } from "@king-ict/eupisi-ui/models";

import { ReligiousAndMinorityInstitutionsDto } from "../../../models/Institution/ReligiousAndMinorityInstitutionsDto";

export const determineInstitutionType = (
  institutionId: number,
  religiousAndMinorityInstitutions?: ReligiousAndMinorityInstitutionsDto
) => {
  const matchingMinoritySchool =
    religiousAndMinorityInstitutions?.minorityInstitutions?.find(
      (school) => school.id === institutionId
    );

  const matchingReligiousSchool =
    religiousAndMinorityInstitutions?.religiousInstitutions?.find(
      (school) => school.id === institutionId
    );

  return {
    isMinoritySchool: !!matchingMinoritySchool,
    isReligiousSchool: !!matchingReligiousSchool,
    schoolId: matchingMinoritySchool?.id || matchingReligiousSchool?.id || null,
  };
};

export const filterAndFindInstitution = (
  institutions: CodeBook[] | undefined,
  selectedId: number | null
): [CodeBook[], CodeBook | undefined] => {
  return (
    institutions?.reduce<[CodeBook[], CodeBook | undefined]>(
      ([filtered, selected], institution) => {
        if (institution.id === selectedId) {
          return [filtered, institution];
        }
        return [[...filtered, institution], selected];
      },
      [[], undefined]
    ) ?? [[], undefined]
  );
};
